<template>
  <transition name="modal-anim">
    <div v-if="isVisible" class="dialog__overlay" @click="CliclToCloseModal">
      <div class="dialog__header"></div>

      <div @click.stop class="dialog__content" @click="CliclToCloseModal">
        <slot @click.stop></slot>
      </div>

      <div class="dialog__header">
        <button class="dialog__close_btn" @click.stop="CliclToCloseModal">
          &times;
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { useModalStore } from "@/stores/modalStore";
import { ref, onMounted } from "vue";

const { closeModal } = useModalStore();

const isVisible = ref(false);

const CliclToCloseModal = () => {
  closeModal();
};

onMounted(() => {
  requestAnimationFrame(() => {
    isVisible.value = true;
  });
});
</script>

<style>
.dialog__overlay {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: flex-start;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  width: 100%;
  height: 100%;
  z-index: 30;
}

.dialog__content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 90vh;
  aspect-ratio: 9 / 15;
}

.dialog__header {
  padding: 12px 12px 0 0;
  width: 25px;
  height: 100%;
}

.dialog__header h3 {
  margin: 0;
  color: #333;
}

.dialog__close_btn {
  font-size: 40px;
  font-weight: bold;
  border: none;
  color: #aeaeb2;
  cursor: pointer;
  transition: color 0.2s;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0);
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog__close_btn:hover {
  color: #8b8b8b;
}

.dialog__overlay .dialog__content {
  animation: content-scale 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes content-scale {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@media (max-width: 600px) {
  .dialog__overlay {
    display: flex;
    flex-direction: column-reverse;
  }

  .dialog__header {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: flex-end;
    padding-top: 0;
    padding-right: 20px;
  }

  .dialog__header:first-child {
    display: none;
  }

  .dialog__content {
    aspect-ratio: 0;
  }
}
</style>
